/*
 * Service configurator: resolves the selected variant from the chosen options,
 * then updates the price, availability, imagery and the hidden `id` field the
 * cart form posts.
 *
 * Option controls are always hidden radios underneath whatever the merchant
 * sees (chips, an upsell toggle or a select), so there is exactly one source of
 * truth for the current selection regardless of how an option is presented.
 */
(function () {
  'use strict';

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function money(cents) {
    if (window.PPTheme && typeof window.PPTheme.formatMoney === 'function') {
      return window.PPTheme.formatMoney(cents);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function Configurator(root) {
    this.root = root;
    this.form = $('form[action*="/cart/add"]', root);

    var dataNode = $('[data-pp-variants]', root);
    try {
      this.variants = JSON.parse(dataNode.textContent);
    } catch (error) {
      this.variants = [];
    }

    this.idInput = $('[data-pp-variant-id]', root);
    this.submit = $('[data-pp-cart-submit]', root);
    this.submitText = $('[data-pp-submit-text]', root);
    this.priceAmount = $('[data-pp-price-amount]', root);
    this.priceCompare = $('[data-pp-price-compare]', root);
    this.stickyPrice = $('[data-pp-sticky-price]', root);
    this.gallery = $('[data-pp-gallery]', root);
    this.quoteButton = $('[data-pp-quote-button]', root);
    this.stickyCta = $('.pp-sticky-bar__cta');
    this.quoteSize = (root.getAttribute('data-pp-quote-size') || '').trim();
    this.optionCount = this.countOptions();

    if (!this.variants.length) return;

    // With JS running, the hidden input is the field that posts the variant.
    if (this.idInput) this.idInput.removeAttribute('disabled');

    this.bind();
    this.syncBoltOnPayment();
    this.update({ replaceState: true });
  }

  Configurator.prototype.countOptions = function () {
    var max = 0;
    $$('[data-pp-option-input]', this.root).forEach(function (input) {
      var position = parseInt(input.getAttribute('data-pp-option-position'), 10);
      if (position > max) max = position;
    });
    return max;
  };

  /** The currently chosen value for each option, indexed by option position. */
  Configurator.prototype.selection = function () {
    var values = new Array(this.optionCount).fill(null);
    $$('[data-pp-option-input]:checked', this.root).forEach(function (input) {
      var index = parseInt(input.getAttribute('data-pp-option-position'), 10) - 1;
      values[index] = input.value;
    });
    return values;
  };

  Configurator.prototype.match = function (values) {
    for (var i = 0; i < this.variants.length; i++) {
      var variant = this.variants[i];
      var hit = true;
      for (var j = 0; j < values.length; j++) {
        if (values[j] !== null && variant.options[j] !== values[j]) {
          hit = false;
          break;
        }
      }
      if (hit) return variant;
    }
    return null;
  };

  Configurator.prototype.isQuoteSelection = function (values) {
    if (!this.quoteSize) return false;
    for (var i = 0; i < values.length; i++) {
      if (values[i] === this.quoteSize) return true;
    }
    return false;
  };

  Configurator.prototype.setQuoteMode = function (on) {
    if (this.quoteButton) this.quoteButton.hidden = !on;
    if (this.submit) this.submit.hidden = on;
    var payment = this.form ? $('.shopify-payment-button', this.form) : null;
    if (payment) payment.hidden = on;
    if (this.stickyCta) {
      if (!this.stickyCtaDefaultHtml) {
        this.stickyCtaDefaultHtml = this.stickyCta.innerHTML;
        this.stickyCtaDefaultHref = this.stickyCta.getAttribute('href');
      }
      if (on && this.quoteButton) {
        this.stickyCta.setAttribute('href', this.quoteButton.getAttribute('href') || '#');
        this.stickyCta.textContent = 'Contact for a quote';
      } else {
        this.stickyCta.setAttribute('href', this.stickyCtaDefaultHref);
        this.stickyCta.innerHTML = this.stickyCtaDefaultHtml;
      }
    }
  };

  /** Cheapest available variant matching a partial selection. */
  Configurator.prototype.cheapest = function (values) {
    var best = null;
    for (var i = 0; i < this.variants.length; i++) {
      var variant = this.variants[i];
      if (!variant.available) continue;
      var hit = true;
      for (var j = 0; j < values.length; j++) {
        if (values[j] !== null && variant.options[j] !== values[j]) {
          hit = false;
          break;
        }
      }
      if (hit && (best === null || variant.price < best.price)) best = variant;
    }
    return best;
  };

  Configurator.prototype.bind = function () {
    var self = this;

    // Chips and the hidden radios behind selects and toggles.
    this.root.addEventListener('change', function (event) {
      if (event.target.matches('[data-pp-option-input]')) {
        self.update({});
        return;
      }

      // Add-on checkboxes mirror their state onto the matching Shopify option.
      // When both cards are selected, use the combined variant value.
      if (event.target.matches('[data-pp-addon-input]')) {
        var checkbox = event.target;
        var position = checkbox.getAttribute('data-pp-option-position');
        var group = checkbox.closest('[data-pp-option-role="addon"]');
        var checked = $$('[data-pp-addon-input]:checked', group);
        var value;

        if (checked.length > 1 && group.getAttribute('data-pp-addon-combined')) {
          value = group.getAttribute('data-pp-addon-combined');
        } else if (checked.length === 1) {
          value = checked[0].getAttribute('data-pp-addon-on');
        } else {
          value = group.getAttribute('data-pp-addon-off');
        }

        self.selectValue(position, value);

        $$(
          '[data-pp-addon-input][data-pp-option-position="' + position + '"]',
          self.root
        ).forEach(function (addonInput) {
          var card = addonInput.closest('[data-pp-addon]');
          if (card) card.setAttribute('data-checked', String(addonInput.checked));
        });

        self.update({});
        return;
      }

      // Package bolt-ons are separate products, not Shopify options.
      if (event.target.matches('[data-pp-bolt-on-input]')) {
        var boltCard = event.target.closest('[data-pp-addon]');
        if (boltCard) boltCard.setAttribute('data-checked', String(event.target.checked));
        self.syncBoltOnPayment();
        self.update({});
        return;
      }

      // Native select for dates and times.
      if (event.target.matches('[data-pp-option-select]')) {
        self.selectValue(
          event.target.getAttribute('data-pp-option-position'),
          event.target.value
        );
        self.update({});
      }
    });
  };

  Configurator.prototype.selectValue = function (position, value) {
    $$(
      '[data-pp-option-input][data-pp-option-position="' + position + '"]',
      this.root
    ).forEach(function (input) {
      input.checked = input.value === value;
    });
  };

  Configurator.prototype.update = function (options) {
    var values = this.selection();
    var variant = this.match(values);

    this.reflectSelectedLabels();
    this.reflectAvailability(values);
    this.reflectAddonPrices(values);

    if (this.isQuoteSelection(values)) {
      if (this.priceAmount) this.priceAmount.textContent = 'Quote';
      if (this.stickyPrice) this.stickyPrice.textContent = 'Quote';
      if (this.priceCompare) this.priceCompare.hidden = true;
      this.setQuoteMode(true);
      this.setSubmit(null);
      return;
    }

    this.setQuoteMode(false);

    if (variant) {
      this.setPrice(variant);
      this.setSubmit(variant);
      this.setMedia(variant);
      if (this.idInput) this.idInput.value = variant.id;
      if (!options.replaceState) this.setUrl(variant);
    } else {
      // No such combination exists in Shopify — show the closest price and
      // block submission rather than posting an id that does not exist.
      var fallback = this.cheapest(values);
      if (fallback) this.setPrice(fallback);
      this.setSubmit(null);
    }
  };

  Configurator.prototype.boltOnTotal = function () {
    var total = 0;
    $$('[data-pp-bolt-on-input]:checked', this.root).forEach(function (input) {
      total += parseInt(input.getAttribute('data-pp-bolt-on-price'), 10) || 0;
    });
    return total;
  };

  Configurator.prototype.syncBoltOnPayment = function () {
    var selected = $$('[data-pp-bolt-on-input]:checked', this.root).length > 0;
    var payment = this.form ? $('.shopify-payment-button', this.form) : null;
    if (payment) payment.hidden = selected;
  };

  Configurator.prototype.setPrice = function (variant) {
    var amount = variant.price + this.boltOnTotal();
    if (this.priceAmount) this.priceAmount.textContent = money(amount);
    if (this.stickyPrice) this.stickyPrice.textContent = money(amount);

    if (this.priceCompare) {
      if (variant.compare && variant.compare > variant.price) {
        this.priceCompare.textContent = money(variant.compare);
        this.priceCompare.hidden = false;
      } else {
        this.priceCompare.hidden = true;
      }
    }
  };

  Configurator.prototype.setSubmit = function (variant) {
    if (!this.submit) return;

    // The appointments app owns this button once it has taken it over.
    if (this.submit.hasAttribute('data-servicify-atc')) return;

    var strings = (window.PPTheme && window.PPTheme.strings) || {};

    if (variant && variant.available) {
      this.submit.disabled = false;
      if (this.submitText) {
        this.submitText.textContent = this.submit.getAttribute('data-pp-submit-label');
      }
    } else {
      this.submit.disabled = true;
      if (this.submitText) {
        this.submitText.textContent = variant
          ? strings.soldOut || 'Unavailable'
          : strings.unavailable || 'Unavailable';
      }
    }
  };

  Configurator.prototype.setMedia = function (variant) {
    if (!this.gallery || !variant.media) return;
    this.gallery.dispatchEvent(
      new CustomEvent('pp:gallery:show', { detail: { mediaId: variant.media } })
    );
  };

  Configurator.prototype.setUrl = function (variant) {
    if (!window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  };

  /** Mirror the chosen value into each option's header. */
  Configurator.prototype.reflectSelectedLabels = function () {
    $$('[data-pp-option]', this.root).forEach(function (group) {
      var checked = $('[data-pp-option-input]:checked', group);
      var label = $('[data-pp-option-selected]', group);
      if (checked && label) label.textContent = checked.value;
    });
  };

  /**
   * Grey out values that cannot be combined with the current selection. They
   * stay clickable so customers can keep exploring; the CTA is what blocks an
   * impossible booking.
   */
  Configurator.prototype.reflectAvailability = function (values) {
    var self = this;

    $$('[data-pp-option-input]', this.root).forEach(function (input) {
      var index = parseInt(input.getAttribute('data-pp-option-position'), 10) - 1;
      var candidate = values.slice();
      candidate[index] = input.value;

      var variant = self.match(candidate);
      var isQuoteCandidate = self.quoteSize && candidate.indexOf(self.quoteSize) !== -1;
      var unavailable = !isQuoteCandidate && (!variant || !variant.available);

      var face = input.parentElement
        ? input.parentElement.querySelector('[data-pp-chip-face]')
        : null;
      if (face) face.setAttribute('data-unavailable', String(unavailable));
    });
  };

  /** Keep each add-on's "+£x" in step with the rest of the configuration. */
  Configurator.prototype.reflectAddonPrices = function (values) {
    var self = this;

    $$('[data-pp-addon-input]', this.root).forEach(function (checkbox) {
      var index = parseInt(checkbox.getAttribute('data-pp-option-position'), 10) - 1;

      var withAddon = values.slice();
      withAddon[index] = checkbox.getAttribute('data-pp-addon-on');
      var withoutAddon = values.slice();
      withoutAddon[index] = checkbox.getAttribute('data-pp-addon-off');

      var on = self.match(withAddon);
      var off = self.match(withoutAddon);
      var card = checkbox.closest('[data-pp-addon]');
      var priceNode = card ? $('.pp-addon__price', card) : null;
      if (!priceNode || !on || !off) return;

      var delta = on.price - off.price;
      priceNode.textContent = delta > 0 ? '+' + money(delta) : '';
    });
  };

  function init() {
    $$('[data-pp-configurator]').forEach(function (root) {
      if (root.ppConfigurator) return;
      root.ppConfigurator = new Configurator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-pp-configurator]')) init();
  });
})();
